import Api from '../api'

const plans = [
  {
    id: 'st-pro-free',
    name: 'No Plan',
    quota: 0,
    seats: 1
  },
  {
    id: 'st-pro-trial',
    name: 'Free Trial',
    quota: 50,
    seats: 1
  },
  {
    id: 'st-pro',
    name: 'DPP Textile',
    quota: 1000,
    seats: 1,
    month: Api.paddle_plans['st-pro'].month,
    year: Api.paddle_plans['st-pro'].year,
    day: Api.paddle_plans['st-pro'].day, // Daily plan for staging
    extras: [
      'plans_feat_passport_page',
      'plans_feat_gs1_digital_link',
      'plans_feat_build_pages',
      'plans_feat_edit_anytime',
      'plans_feat_multilingual',
      'plans_feat_branded_qr',
      'plans_feat_image_library',
      'plans_feat_print_ready_qr',
      'plans_feat_consumer_questions',
      'plans_feat_scan_insights'
    ]
  },
  {
    id: 'enterprise',
    quota: 'custom',
    seats: 'custom',
    extras: [
      'plans_feat_copy_detection',
      'plans_feat_serialisation',
      'plans_feat_print_partner_qa',
      'plans_feat_traceability',
      'plans_feat_counterfeit_monitor',
      'plans_feat_custom_experiences',
      'plans_feat_domains_redirection',
      'plans_extra_bulk_upload',
      'plans_extra_amazon_transparency',
      'plans_feat_bi_exports',
      'plans_feat_users_sso_2fa',
      'plans_feat_dedicated_onboarding'
    ]
  }
]

export default plans

export function getPlanName (plan) {
  if (!plan) {
    return ''
  }
  const known = plans.find((item) => item.id === plan.id)
  return known?.name || plan.name || ''
}
